import { Component } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'all-supply-component',
  templateUrl: './all-supply.component.html',
  styleUrls: ['./all-supply.component.scss'],
})
export class AllSupplyComponent {
  constructor(public ga: GoogleAnalyticsService) {}

  ngOnDestroy() {}
}
